export enum UserType {
  NotSet = 'not_set',
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}
